/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForJiraServiceManagement extends models.GovernanceConfigurationBaseForItsm {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForJiraServiceManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForJiraServiceManagement>): GovernanceConfigurationBaseForJiraServiceManagement {
        let obj = Object.assign(new GovernanceConfigurationBaseForJiraServiceManagement(), model);
        GovernanceConfigurationBaseForJiraServiceManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForJiraServiceManagement>): GovernanceConfigurationBaseForJiraServiceManagement {
        if (!model) return null;
        return GovernanceConfigurationBaseForJiraServiceManagement.newInstance(<GovernanceConfigurationBaseForJiraServiceManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForJiraServiceManagement) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForJiraServiceManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForJiraServiceManagement): boolean {
        if (models.GovernanceConfigurationBaseForItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForJiraServiceManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
